import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Box, Typography, Button, Modal, TextField } from "@mui/material";

export default function EditCreateCategory(props) {
  const { isOpen, title, description, confirmText = "Submit", cancelText = "Cancel", onConfirm, onCancel, onClose, catName } = props;

  const [name, setName] = useState('')
  useEffect(() => {
    if (catName) setName(catName)
    return () => setName('')
  }, [catName])
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <Typography id="modal-modal-title">
            {description}
          </Typography>
          <Box sx={{ mt: 2 }}>
            <TextField
              id="outlined-controlled"
              label="Category Name"
              value={name}
              fullWidth
              onChange={(event) => {
                setName(event.target.value);
              }}
            />
          </Box>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={onCancel}>
              {cancelText}
            </Button>
            <Button
              variant="outlined"
              onClick={() => onConfirm(name)}
            >
              {confirmText}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>,
    document.body
  );
};
